<template>
	<div class="table-base">
		<el-table ref="tableRef" v-loading="loading" :data="data" v-bind="tableConfig">
			<template v-for="column in columns">
				<el-table-column v-bind="column" :key="column.prop || column.label">
					<template slot-scope="scope">
						{{
							scope.row[column.prop]
								? scope.row[column.prop]
								: scope.row[column.prop] === null
								? '--'
								: scope.row[column.prop]
						}}
					</template>
				</el-table-column>
			</template>
		</el-table>

		<gc-empty v-if="showEmpty && (!data || data.length === 0) && !loading" :type="emptyType" :text="emptyText" />
	</div>
</template>

<script>
export default {
	name: 'TableBase',
	props: {
		data: {
			type: Array,
			default: () => [],
		},

		columns: {
			type: Array,
			default: () => [],
		},

		emptyText: {
			type: String,
			default: '暂无数据',
		},

		loading: {
			type: Boolean,
			default: false,
		},

		showEmpty: {
			type: Boolean,
			default: true,
		},

		config: {
			type: Object,
			default: () => {},
		},
		summary: {
			type: Function,
			default: null,
		},
	},
	computed: {
		tableConfig() {
			return {
				stripe: false,
				border: true,
				pagination: false,
				fit: true,
				showSummary: !!this.summary,
				summaryMethod: this.summary || (() => []),
				...this.config,
			}
		},
	},
}
</script>

<style lang="scss" scoped>
.table-base {
	width: 100%;

	/* 表格样式 */
	::v-deep .el-table {
		width: 100%;
		font-size: 11px;
		border-collapse: collapse;
		border-top: 1px solid #e1e2ec;
		border-left: 1px solid #e1e2ec;

		.el-table__header {
			th {
				background-color: #ebecf4;
				color: #303133;
				font-weight: bold;
				padding: 5px 0;
			}
		}

		.el-table__footer,
		.el-table__body {
			td {
				padding: 5px 0;
			}
		}

		td.el-table__cell,
		th.el-table__cell {
			border-bottom: 1px solid #e1e2ec;
			border-right: 1px solid #e1e2ec;
		}
	}
}
</style>
